export const money = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const compactMoney = (n) => {
  const v = Number(n || 0);
  const abs = Math.abs(v);
  const short = (value, suffix) =>
    "$" + new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(value) + suffix;
  if (abs >= 1e9) return short(v / 1e9, "B");
  if (abs >= 1e6) return short(v / 1e6, "M");
  if (abs >= 1000) return short(v / 1000, "K");
  return money(v);
};

export const pct = (n, digits = 1) => `${Number(n || 0).toFixed(digits)}%`;
